import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { ValidatorsService } from 'src/app/validators/validators.service';
import * as CryptoJS from 'crypto-js';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userDetails: any;
  secretKey = "(!@#Passcode!@#)";
  currpasshide = true;
  newpasshide = true;
  conpasshide = true;
  accountSettingsForm: UntypedFormGroup;
  email: any;
  orgImage: any;
  // blobToken: string = environment.blobKey;
  blobToken: string = environment.blobKey2;
  profImage: string = environment.profileUrl;
  constructor(
    public dialog: MatDialog,
    private commonService:CommonService,
    private gvs: ValidatorsService,
    private fb: UntypedFormBuilder,
    public route: ActivatedRoute,
    public toast: ToastrService)
    { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.email = CryptoJS.AES.decrypt(this.userDetails?.email, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
    this.orgImage = JSON.parse(localStorage.getItem('orgImage'));
    this.orgImage.img = this.orgImage.img.startsWith('https://') ? this.orgImage.img : this.profImage + this.orgImage.img + this.blobToken;
    this.accountSettingsFormInitialize();
  }

  accountSettingsFormInitialize() {
    this.accountSettingsForm = this.fb.group({
      currentPassword: ['', [Validators.required, this.gvs.passwordRegex(), Validators.minLength(8), Validators.maxLength(50)]],
      password: ['', [Validators.required, this.gvs.passwordRegex(), Validators.minLength(8), Validators.maxLength(50)]],
      confirmPassword: ['', [Validators.required]],
      }, { validators: this.gvs.passwordMatcher()
    })
  }

  changePassword() {
    if (this.accountSettingsForm.valid) {
      const encryptPass = CryptoJS.AES.encrypt(this.accountSettingsForm.value.password.trim(),this.secretKey.trim()).toString();
      const currentencryptPass = CryptoJS.AES.encrypt(this.accountSettingsForm.value.currentPassword.trim(),this.secretKey.trim()).toString();
      let data = {
        "email": this.userDetails.email,
        "newpassword": encryptPass,
        "currentpassword": currentencryptPass,
      };
      this.commonService.updatePassword(data).subscribe((resp: any) => {
        if (resp.success) {
          this.toast.success('',resp.message)
          this.commonService.logout();
        } else {
          this.toast.error('',resp.message)
        }
      })
    } else {
      this.gvs.validateAllFields(this.accountSettingsForm);
    }
  }

  get currentPassword() {
    return this.accountSettingsForm.get('currentPassword');
  }
  get password() {
    return this.accountSettingsForm.get('password');
  }
  get confirmPassword() {
    return this.accountSettingsForm.get('confirmPassword');
  }

  openDetail(template:TemplateRef<any>) {
    this.dialog.open(template, {
      width: '30%',
      height: '40%',
      panelClass: 'passwordPopup',
      closeOnNavigation: true,
      disableClose: true,
    });
  }
  logout () {
    Swal.fire({
      customClass: {
        container: 'swalClass',
      },
      title: 'Are you sure you want to Sign out?',
      showCancelButton: true,
      confirmButtonColor: '#ffffff',
      cancelButtonColor: '#ffffff',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if(result?.isConfirmed) {
        this.commonService.logout();
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
    this.accountSettingsForm.reset();
  }

  ngOnDestroy() {
    // this.dialog.closeAll();
  }
}
